// extracted by mini-css-extract-plugin
export default {"custom_message":"ProjectTableStyles_custom_message__s1gr4","projectBtn":"ProjectTableStyles_projectBtn__hdkDb"};